// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","970":"component---src-pages-about-tsx"}[chunkId] || chunkId) + "-" + {"245":"c06ba457c869eda35321","453":"8f0da94903af50d22efd","570":"9abd06b6f447ae2f2696","739":"633e44fd5d75b65ce84d","970":"de75467e3aa20cc0da71"}[chunkId] + ".js";
};